export const SITE_URL = process.env.NEXT_PUBLIC_SITE_DOMAIN
  ? `https://${process.env.NEXT_PUBLIC_SITE_DOMAIN}`
  : 'http://localhost:3000'

export const FACEBOOK_APP_ID = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID || ''
export const SITE_TWITTER_HANDLE = process.env.NEXT_PUBLIC_SITE_TWITTER_HANDLE || ''
